<template>
  <div class="bg" style="height: 99%;overflow: hidden">
<!--    <index-chart></index-chart>-->
    <trace-data v-if="isHas"></trace-data>
    <trace-search v-else></trace-search>
  </div>
</template>

<script>
  import IndexChart from './IndexChart'
  import { mapState } from 'vuex'
  import TraceSearch from '@views/dashboard/traceSearch.vue'
  import TraceData from '@views/trace/traceData.vue'

  export default {
    name: "Analysis",
    components: {
      TraceSearch,
      IndexChart,
      TraceData
    },
    data() {
      return {
        isHas: false,
      }
    },
    computed: {
    ...mapState({
      // 后台菜单
      permissionMenuList: state => state.user.permissionList
    })
  },
    created() {
      console.log(this.permissionMenuList,'permissionMenuList======================')
      // 判断是否存在标识编码菜单，如果存在则展示追溯搜索页面，如果不存在则展示站内搜索页面
      this.isHas = this.permissionMenuList.some(item => item.url === '/identifierCode')
      console.log(this.isHas,'this.isHas======================')
      // if ( this.isHas ){

      // }
    },
    methods: {

    }
  }
</script>
<style >
.bg{
  background-image: url("/static/traceBg.jpg");
  background-size: 100% 100%;
}
</style>